import { ng1ParentModule } from 'core/common/util/ng-helper';
import 'ui-select';

export const coreComponents = ng1ParentModule(
    'eservice.core.components',
    require.context('./', true, /.+\.ts/),
    {loadSubContents: true, dependencies: ['eservice.core', 'ui.select']}
);


// WEBPACK FOOTER //
// ./src/ui/core/common/components/components.ts